import { render, staticRenderFns } from "./NewsViews.vue?vue&type=template&id=3eec8a66&scoped=true&"
import script from "./NewsViews.vue?vue&type=script&lang=js&"
export * from "./NewsViews.vue?vue&type=script&lang=js&"
import style0 from "./NewsViews.vue?vue&type=style&index=0&id=3eec8a66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eec8a66",
  null
  
)

component.options.__file = "NewsViews.vue"
export default component.exports